module.exports = __webpack_public_path__ + "media/audio49.0d1d518c.mp3";